import React from 'react';
import { useData } from '../../store/DataContext';
import { Card } from '../../components/ui/Card';
import { Users, Activity, Stethoscope, FlaskConical, Scan, Pill, CheckCircle } from 'lucide-react';
export const AdminDashboard: React.FC = () => {
  const {
    users,
    patients,
    encounters
  } = useData();
  const activeEncounters = encounters.filter(e => e.stage !== 'COMPLETED');
  const stats = {
    totalStaff: users.length,
    totalPatients: patients.length,
    activeEncounters: activeEncounters.length,
    withNursing: encounters.filter(e => e.stage === 'NURSING').length,
    withClinician: encounters.filter(e => e.stage === 'CLINICIAN').length,
    labOrdered: encounters.filter(e => e.stage === 'INVESTIGATIONS' && e.pendingLab).length,
    radOrdered: encounters.filter(e => e.stage === 'INVESTIGATIONS' && e.pendingRadiology).length,
    withPharmacy: encounters.filter(e => e.stage === 'PHARMACY').length,
    completedToday: encounters.filter(e => e.stage === 'COMPLETED' && new Date(e.startedAt).toDateString() === new Date().toDateString()).length
  };
  const StatCard = ({
    title,
    value,
    icon: Icon,
    colorClass
  }: any) => <div className="bg-white overflow-hidden shadow rounded-lg border border-gray-200" data-id="element-273" data-mp="2rhq0qipbhrv4">
      <div className="p-5" data-id="element-274" data-mp="2nih7rg23py0m">
        <div className="flex items-center" data-id="element-275" data-mp="2ni7sonilhb9p">
          <div className="flex-shrink-0" data-id="element-276" data-mp="1zrk40qkgm70g">
            <Icon className={`h-6 w-6 ${colorClass}`} aria-hidden="true" data-id="element-277" data-mp="1zsdh09a0hsr1" />
          </div>
          <div className="ml-5 w-0 flex-1" data-id="element-278" data-mp="1uu26rxft1g8a">
            <dl data-id="element-279" data-mp="1uv3je6cgyas4">
              <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-280" data-mp="28sa1dypdc5ga">
                {title}
              </dt>
              <dd data-id="element-281" data-mp="23t5ph0b27tm9">
                <div className="text-2xl font-bold text-gray-900" data-id="element-282" data-mp="23snmzlxt0j5w">{value}</div>
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>;
  return <div className="space-y-6" data-id="element-283" data-mp="3f9dlsjzwe8ph">
      <h1 className="text-2xl font-bold text-gray-900" data-id="element-284" data-mp="3f82facf2imuo">System Overview</h1>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-285" data-mp="2cu4n2f4xw47d">
        <StatCard title="Total Staff" value={stats.totalStaff} icon={Users} colorClass="text-blue-500" data-id="element-286" data-mp="2htratiie92uf" />
        <StatCard title="Total Registered Patients" value={stats.totalPatients} icon={Users} colorClass="text-green-500" data-id="element-287" data-mp="2lwnkuktvbqmr" />
        <StatCard title="Active Encounters" value={stats.activeEncounters} icon={Activity} colorClass="text-red-500" data-id="element-288" data-mp="1u5pz60px56as" />
      </div>

      <h2 className="text-lg font-medium text-gray-900 mt-8" data-id="element-289" data-mp="234uwx4tnovlw">
        Current Department Load
      </h2>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-290" data-mp="27wctzhsk6c1l">
        <StatCard title="Waiting Nursing" value={stats.withNursing} icon={Activity} colorClass="text-blue-500" data-id="element-291" data-mp="1agyy9ukj0tmh" />
        <StatCard title="Waiting Clinician" value={stats.withClinician} icon={Stethoscope} colorClass="text-indigo-500" data-id="element-292" data-mp="1fdz8mhoesije" />
        <StatCard title="Pending Lab" value={stats.labOrdered} icon={FlaskConical} colorClass="text-yellow-500" data-id="element-293" data-mp="12y7wfu44uvkn" />
        <StatCard title="Pending Radiology" value={stats.radOrdered} icon={Scan} colorClass="text-purple-500" data-id="element-294" data-mp="twrw6f7189u5" />
        <StatCard title="Waiting Pharmacy" value={stats.withPharmacy} icon={Pill} colorClass="text-teal-500" data-id="element-295" data-mp="oyq1sy45oo3d" />
        <StatCard title="Completed Today" value={stats.completedToday} icon={CheckCircle} colorClass="text-green-500" data-id="element-296" data-mp="f6u2xku8wty3" />
      </div>
    </div>;
};